'use client'

import { useCallback, useState } from 'react'
import { useTranslations } from 'next-intl'

import { useBookingState } from '@booking/state/booking.context'

import styles from './index.module.scss'
import TicketRow from './components/TicketRow'
import { variantTranslationKey } from '../../lib/bookingConfig'

function normalizeEmail(value: string): string {
  return value.trim().toLowerCase()
}

export default function AssociateBox() {
  const t = useTranslations('booking')
  const { cart } = useBookingState()
  const [emails, setEmails] = useState<string[]>([])

  const lines = cart && cart.type === 'standard' ? cart?.lines : []

  const onRowComplete = useCallback((state: boolean, payload: { email: string }) => {
    const email = normalizeEmail(payload.email)
    if (!email) return

    setEmails((previous) => {
      if (state) {
        if (previous.includes(email)) return previous
        return [...previous, email]
      }
      return previous.filter((value) => value !== email)
    })
  }, [])

  const openCopy = t.raw('ticket.success.openCopy')

  if (!cart || !lines || lines.length === 0) return <></>

  return (
    <div className={styles.box}>
      <h3>{t('ticket.success.openTitle')}</h3>

      {typeof openCopy === 'string' ? (
        <div className={styles.copy} dangerouslySetInnerHTML={{ __html: openCopy }} />
      ) : null}

      <div className={styles.ticketRows}>
        {lines.map((line, index) => (
          <TicketRow
            key={`${line.id ?? index}`}
            cartId={cart.id}
            line={line}
            index={index}
            ticketName={t(`variants.${variantTranslationKey(line.category)}`)}
            existingEmails={emails}
            onCompleteChange={onRowComplete}
          />
        ))}
      </div>
    </div>
  )
}
